import { ProductCallToAction } from "@/redux/modules/api/data/cart/@types/cart.types";

type Props = {
    cta: ProductCallToAction;
};

const Action = ({ cta }: Props) => {
    const silentAction = cta.actions.find((a) => !a.visual);

    return <>{silentAction?.action?.(cta.product, silentAction)}</>;
};

export default Action;
